// Extensions the browser can render inline via <img>. Anything else (pdf, docx,
// heic, ...) is intentionally excluded from the preview modal — those files stay
// table-only, since this is strictly an image viewer (see issue #31493).
const RENDERABLE_IMAGE_EXTENSIONS = new Set(['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp']);

export function isRenderableImage(path) {
  if (!path) {
    return false;
  }
  const lastDot = path.lastIndexOf('.');
  if (lastDot === -1 || lastDot === path.length - 1) {
    return false;
  }
  return RENDERABLE_IMAGE_EXTENSIONS.has(path.slice(lastDot + 1).toLowerCase());
}
